/* 
  就是把不同模块的 state attion。。。。放到一个对象里面去
*/
import { getConfig, indexBanner, fourBanner, adBanner } from "@/api/app"
import { getImageUrl } from "@/utils/imageUrl"
/*
 * @Descripttion:
 * @version:
 * @Author:
 * @Date: 2022-03-06 11:23:28
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-14 13:50:38
 */
const state = {
  token:'',
  seo:{PageTitle:'',PagekeyWords:'',PageDescription:'',},
  load_one:true,
  locale: 'zh-CN',
  navInfo:{
    navList:[
      // 官网
      {name:'首页',path:'/',},{name:'关于我们',path:'/Intro',},
      {name:'产品中心',path:'/Product',},{name:'工厂展示',path:'/Factory',},
      {name:'销售网络',path:'/Network',},{name:'服务支持',path:'/Service',},
      {name:'新闻动态',path:'/Enterprise',},{name:'联系我们',path:'/Contact',},

      // 商城
      {name:'商城',path:'/Mall',},
    ],
    carNum:0,
    icp:'',address:'',tel:'',email:'',web:'',logo:'',
    contact_img:'',map_url:'',
  },
  indexBannerList:[],
  sonBanner:{},
  index_about:{img:'',index_intro:'',intro:'',about_culture:'',sales_network:'',service_support:'',},
  index_product:[],
  index_video:'',
  userInfo:{id:0,username:'',mobile:'',avatar:''},
}

// mutations主要用来操作state
const mutations = {
  setIndexBanner(state, indexBannerList) {
    state.indexBannerList = indexBannerList;
  },
  setIndexVideo(state, index_video) {
    state.index_video = index_video;
  },
  setIndexProduct(state, index_product) {
    state.index_product = index_product;
  },
  setIndexAbout(state, index_about) {
    state.index_about = index_about;
  },
  setSonBanner(state, sonBanner) {
    state.sonBanner = sonBanner;
  },
  setNav(state, navInfo){
    state.navInfo = navInfo;
  },
  setToken(state, token){
    state.token = token;
  },
  setUserInfo(state, userInfo){
    state.userInfo = userInfo;
  },
  setSeo(state, seo) {
    state.seo = seo;
  },
  setLoad(state,load_one){
    state.load_one = load_one;
  },
  setLocale(state, locale) {
    state.locale = locale;
  }
}

// getters计算属性
const getters = {
  indexBanner: state =>state.indexBannerList,
  indexVideo: state =>state.index_video,
  indexProduct: state =>state.index_product,
  indexAbout: state =>state.index_about,
  sonBanner: state =>state.sonBanner,
  computedNav: state => state.navInfo,
  computedSeo1: state => state.seo.PageTitle,
  computedSeo2: state => state.seo.PagekeyWords,
  computedSeo3: state => state.seo.PageDescription,
  computedLoad: state => state.load_one,
  currentLocale: state => state.locale,
  computedToken: state => state.token,
  computedUserInfo: state => state.userInfo,
}

// actions异步请求处理
const actions = {
  // 首页轮播图
  async getIndexBanner({ state, commit }){
    let {data} = await indexBanner();
    if(data.code == 1){
      commit('setIndexBanner', data.data.map(item => ({...item, image: getImageUrl(item.image)})));
    }else{
      this.$message.error(data.msg);
    }
  },
  // 四大产品
  async getFourBanner({ state, commit }){
    let {data} = await fourBanner();
    if(data.code == 1){
      commit('setIndexProduct', data.data.map(item => ({...item, image: getImageUrl(item.image)})));
    }else{
      this.$message.error(data.msg);
    }
  },
  // 配置
  async _getConfig({ state, commit }) {
    let {data} = await getConfig({key:''});
    if(data.code == 1){
      commit('setLoad',false);

      // seo
      let seo = {PageTitle:'',PagekeyWords:'',PageDescription:'',}
      if(window.localStorage.getItem('language') == 'en'){
        seo.PageTitle = data.data.seo_title_en;
        seo.PagekeyWords = data.data.seo_keywords_en;
        seo.PageDescription = data.data.seo_desc_en;
      }else{
        seo.PageTitle = data.data.seo_title;
        seo.PagekeyWords = data.data.seo_keywords;
        seo.PageDescription = data.data.seo_desc;
      }
      commit('setSeo',seo);

      // 网站配置
      let temp = state.navInfo;
      temp.icp = data.data.record_number;
      temp.address = data.data.address;
      temp.tel = data.data.mobile;
      temp.email = data.data.email;
      temp.web = data.data.baixin_web;
      temp.logo = getImageUrl(data.data.logo);
      temp.contact_img = getImageUrl(data.data.contact_img);
      temp.map_url = data.data.map_url;
      commit('setNav', temp);

      let obj = {image: getImageUrl(data.data.about_us_images)};
      commit('setSonBanner',obj);

      // 关于我们 企业文化 销售网络 服务支持 联系我们图片
      let about = {}
      if(window.localStorage.getItem('language') == 'en'){
        about = {
          img:getImageUrl(data.data.about_img),
          index_intro:data.data.aboutus_index_en,
          intro:data.data.about_us_en,
          about_culture:data.data.about_culture_en,
          sales_network:data.data.sales_network_en,
          service_support:data.data.service_support_en,
        };
      }else{
        about = {
          img:getImageUrl(data.data.about_img),
          index_intro:data.data.aboutus_index,
          intro:data.data.about_us,
          about_culture:data.data.about_culture,
          sales_network:data.data.sales_network,
          service_support:data.data.service_support,
        };
      }
      commit('setIndexAbout',about);

      // 企业动态 视频
      let video = {
        type:'video',
        poster:getImageUrl('/pcImgs/play-img.png'),
        url:getImageUrl(data.data.news_video),
      };
      commit('setIndexVideo',video);

    }else{
      this.$message.error(data.msg);
    }
  },
  // 购物车数量
  changeCartNum({ state, commit }, carNum){
    let temp = state.navInfo;
    temp.carNum = carNum;
    commit('setNav', temp);
  },
  // 设置导航栏
  _getNavList({ state, commit }, navList){
    let temp = state.navInfo;
    temp.navList = navList;
    commit('setNav', temp);
  },
  // 语言
  changeLocale({ commit }, locale) {
    commit('setLocale', locale);
  },
  // token
  changeToken({ commit }, token){
    commit('setToken', token);
  },
  changeInfo({ commit }, userinfo){
    commit('setUserInfo', userinfo);
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
